export default __webpack_public_path__ + "static/color-picker-accessible-role-dont-058de22507086b07e2d2ac41caa2bdef.png";